import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC } from 'react'

import { MediaGalleryBlockType } from '@Blocks/MediaGalleryBlock/MediaGalleryBlockType'
import { MediaGalleryDefaultCard } from '@Blocks/MediaGalleryBlock/MediaGalleryDefaultBlock/Components/MediaGalleryDefaultCard/MediaGalleryDefaultCard'
import { MediaGalleryCardProps } from '@Components/MediaGalleryCard'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { HorizontalCarousel } from '@Shared/Components/Carousels/HorizontalCarousel/HorizontalCarousel'

import styles from './MediaGalleryDefaultBlock.module.scss'

interface MediaGalleryDefaultBlockProps extends MediaGalleryBlockType {
  fullWidth?: boolean
  isInjection?: boolean
  zigzag?: boolean
}

export const MediaGalleryDefaultBlock: FC<MediaGalleryDefaultBlockProps> = ({
  cards,
  fullWidth = false,
  isInjection = false,
  zigzag = false,
}) => {
  const openModal = useCMSModalOpen()

  return (
    <div className={clsx(styles.mediaGalleryBannerBlock, fullWidth && styles.fullWidth, isInjection && styles.injected)}>
      <HorizontalCarousel
        buttonFloat
        buttonsCarouselClass={styles.buttonsCarouselClass}
        carouselClassName={clsx(styles.horizontalCarousel, fullWidth && styles.carouselFullWidth, zigzag && styles.zigzag)}
        className={styles.carousel}
        gap={isInjection ? 6 : 10}
        halfSizeProgressBar
        progressClassName={styles.progressCarousel}
        showProgressbar
        snap
      >
        {map(cards, (card: MediaGalleryCardProps) => (
          <MediaGalleryDefaultCard
            key={card.id}
            card={card}
            openModal={(type, id) => {
              if (type && id) {
                openModal(type, id)
              }
            }}
          />
        ))}
      </HorizontalCarousel>
    </div>
  )
}
